/* eslint-disable max-len */
<template>
  <div class="map-container">
    <div class="legend">
      <div class="legend-top-number">100%<br />of matches</div>
      <div class="legend-gradient" />
      <div class="legend-bottom-number">0%<br />of matches</div>
    </div>
    <div class="map-tooltip elevation-6" id="mapTooltip">Tooltip</div>
    <svg
      class="svg-map"
      viewBox="0 0 1831 3205"
      preserveAspectRatio="xMinYMin meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="finland-map"
    >
      <g id="finland-regions">
        <g v-for="area in mapData" :key="area.id" class="area">
          <path
            :class="[searchTerms.area === area.name ? 'active-area' : '']"
            :style="heatMap(area.name, area.id)"
            @click="doSearch(area.name)"
            :id="area.id"
            :d="area.shape"
            @mouseover="areaMouseOver(area.id, area.name)"
            @mousemove="areaMouseMove"
            @mouseout="areaMouseOut"
          ></path>
          <circle
            v-for="city in area.cities"
            :key="city.id"
            :cx="city.x"
            :cy="city.y"
            r="40"
            fill="blue"
            class="city"
            @click="doSearch(city.name)"
            @mouseover="areaMouseOver(city.id, city.name)"
            @mousemove="areaMouseMove"
            @mouseout="areaMouseOut"
          >
          </circle>
        </g>
      </g>
    </svg>
  </div>
</template>


<script>
import { debounce } from "debounce";

export default {
  name: "StaticFinlandMap",
  props: {
    graph: {
      type: Array,
      required: true,
    },
    searchTerms: {
      required: false,
    },
  },
  data() {
    return {
      areaHits: {
        paijatHame: 0,
        southOstrobothnia: 0,
        kantaHame: 0,
        southKarelia: 0,
        kymenlaakso: 0,
        uusimaa: 0,
        lapland: 0,
        northKarelia: 0,
        southSavo: 0,
        northSavo: 0,
        kainuu: 0,
        centralFinland: 0,
        ostrobothnia: 0,
        satakunta: 0,
        southwestFinland: 0,
        centralOstrobothnia: 0,
        pirkanmaa: 0,
        northOstrobothnia: 0,
        aland: 0
      },
    };
  },
  computed: {
    matchPositions() {
      return this.graph.filter((position) => position.match);
    },
    mapData() {
      return this.$store.state.mapData;
    },
    drawer: {
      get() {
        return this.$store.state.mapVisibility;
      },
      set(val) {
        this.$store.dispatch("commitMapVisibility", val);
      },
    },
  },
  methods: {
    areaMouseOver(id, title) {
      let map = document.getElementById("finland-map");
      let offsetTop = map.parentNode.offsetTop;
      let offsetLeft = map.parentNode.offsetLeft;
      let y = event.offsetY + offsetTop;
      let x = event.offsetX + offsetLeft;
      let tooltip = document.getElementById("mapTooltip");
      tooltip.style.top = y + "px";
      tooltip.style.left = x + "px";
      tooltip.style.visibility = "visible";
      tooltip.innerHTML = title;
    },
    areaMouseOut() {
      let tooltip = document.getElementById("mapTooltip");
      tooltip.style.visibility = "hidden";
    },
    areaMouseMove() {
      let map = document.getElementById("finland-map");
      let offsetTop = map.parentNode.offsetTop;
      let offsetLeft = map.parentNode.offsetLeft;
      let y = event.offsetY + offsetTop;
      let x = event.offsetX + offsetLeft;
      let tooltip = document.getElementById("mapTooltip");
      tooltip.style.top = y + "px";
      tooltip.style.left = x + "px";
    },
    heatMap(areaName, areaId) {
      const allPositions = this.matchPositions.length;
      const searchResults = JSON.stringify(this.matchPositions);
      const regExp = new RegExp(areaName, "ig");
      const hitCount = ((searchResults || "").match(regExp) || []).length;
      const percentage = hitCount / allPositions;
      const styleOpacity = 0.2 + percentage;
      let hitStyle;
      if (!hitCount) {
        hitStyle = "fill: rgba(0, 0, 0, .05)";
        this.areaHits[areaId] = 0;
      } else {
        hitStyle = `fill: rgba(0, 45, 160, ${styleOpacity})`;
        this.areaHits[areaId] = hitCount;
      }
      //console.log(`${areaName} --> ${percentage} ==> ${hitStyle}`);
      return hitStyle;
    },
    // eslint-disable-next-line func-names
    doSearch: debounce(function (area) {
      const terms = {
        keywords: this.searchTerms.keywords,
        area,
      };
      this.$store.dispatch("commitSearchTerms", terms);
      this.$store.dispatch("commitSearchResults", terms);
      // Emit update event
      this.$emit("regionUpdated", area);
    }, 300),
  },
};
</script>
<style scoped>
.map-container {
  display: flex;
  height: 320px;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  margin-left: 1em;
  margin-right: 1em;
}
.legend {
  position: fixed;
  top: 30%;
  left: 20px;
  text-align: center;
  font-size: 0.6rem;
  text-transform: uppercase;
}
.map-tooltip {
  position: absolute;
  background: white;
  transform-origin: left top;
  pointer-events: none;
  visibility: hidden;
  white-space: nowrap;
  padding: 3px 8px;
  transform: translateY(-3px) translateY(-6px);
  border-radius: 3px;
}
.legend-gradient {
  display: block;
  margin: 1rem auto;
  width: 20%;
  max-width: 20px;
  border-radius: 6px;
  height: 140px;
  background: linear-gradient(rgba(0, 45, 160, 1), rgba(0, 45, 160, 0));
}

.svg-map {
  height: 300px;
}
.active-area {
  stroke: rgba(0, 45, 160, 0.8);
}
.city{
  fill: rgb(255, 255, 255);
  stroke: rgba(0, 45, 160, 0.8);
  stroke-width: 3px;
  cursor: pointer;
}
.city:hover{
  fill:  rgba(0, 45, 160, 0.8);
}
svg .area text {
  visibility: hidden;
}
svg .area path:hover + text {
  visibility: visible;
  pointer-events: none;
}
.svg-map path {
  fill: rgba(0, 45, 160, 0.3);
  transition: fill 0.3s linear;
  stroke: rgba(0, 45, 160, 0.8);
  stroke-width: 3px;
}
.svg-map path:hover,
.svg-map path:active {
  cursor: pointer;
  fill: rgba(0, 45, 160, 0.8) !important;
}
@media screen and (min-width: 992px) {
  .map-container {
    display: flex;
    height: 80vh;
    min-height: 100%;
    align-items: center;
    justify-content: center;
  }
  .svg-map {
    height: 75vh;
  }
}
</style>
